// tslint:disable-next-line:max-line-length
import { ModalSeleccionFuncionarioComponent } from './../../../../../layouts/modal-seleccion-funcionario/modal-seleccion-funcionario.component';
import { ModuloAyudaService } from './../../configuracion/modulo-ayuda/modulo-ayuda.service';
import { DocumentoSubcategoriaService } from './../../configuracion/documento-subcategoria/documento-subcategoria.service';
import { CampoAdicionalCategoriaService } from './../../configuracion/campo-adicional-categoria/campo-adicional-categoria.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { CamaraComercioEntry } from 'src/app/shared/entrys/camara-comercio';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { UsuarioService } from '../../configuracion/usuario/usuario.service';
import { EstablecimientoComercioService } from '../../../prestador/establecimiento-comercio/establecimiento-comercio.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { AccionRntService } from '../../configuracion/accion-rnt/accion-rnt.service';
import { ReportesTramitesService } from './reportes-tramites.service';
import { NgbModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { HttpEventType } from '@angular/common/http';
import * as FileSaver from 'file-saver';

import { DepartamentoEntry } from "src/app/shared/entrys/departamento.entry";
import { MunicipioEntry } from "src/app/shared/entrys/municipio.entry";
import { CategoriaEntry } from "src/app/shared/entrys/categoria.entry";
import { SubCategoriaEntry } from "src/app/shared/entrys/sub-categoria.entry";

import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { ReportesEstablecimientosService } from "../../reportes/establecimientos/reportes-establecimientos.service";


@Component({
// tslint:disable-next-line:indent
    selector: 'app-reportes-tramites',
// tslint:disable-next-line:indent
    templateUrl: './reportes-tramites.component.html',
// tslint:disable-next-line:indent
    styleUrls: ['./reportes-tramites.component.scss']
})
export class ReportesTramitesComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerTabla: Array<string>;
	formUsuario: FormGroup;
	camarasLista: Array<CamaraComercioEntry>;
	paginaActual: number;
	adminSuper = RolesUsuario.AdministradorSuper;
	prestador = RolesUsuario.Prestador;
	adminCC = RolesUsuario.AdministradorCC;
	columnas: Array<any> = [];
	columnasEnvio: any;
	// filtros
	filtro: FormGroup;
	formCheck: FormGroup;
	public isCollapsed = true;
	isExportar = true;
	camaraComercio: string;
	// Selects
	tipoSolicitud: Array<any> = [];
	estadoSolicitud: Array<any> = [];
	fecha_inicio: any;
	exportarForm: FormGroup;
	exportarList = [
		{id: 'Desc_Camara', name: 'Cámara de Comercio'},
		{id: 'Descripcion_Tipo_Solicitud', name: 'Tipo de solicitud'},
		{id: 'Descripcion_Estado_Solicitud', name: 'Estado de Solicitud'},
		{id: 'Fecha_Radicacion', name: 'Fecha de Radicación'},
		{id: 'Numero_Identificacion', name: 'Nit'},
		{id: 'Matricula', name: 'Matrícula'},
		{id: 'Razon_Social', name: 'Nombre o Razón social'},
		{id: 'Numero_Identificacion_Usuario_Tramite', name: 'Identificación Usuario Trámite'},
		{id: 'Tipo_Usuario_Tramite', name: 'Tipo Usuario Trámite'},
		{id: 'Codigo_Rnt', name: 'Número Rnt'},
		{id: 'Nombre_Funcionario', name: 'Funcionario'},
		{id: 'Numero_Radicacion', name: 'Número Radicado'},
        {id: 'Desc_Categoria', name:'Categoria'},
        {id: 'Desc_Sub_Categoria', name:'SubCategoria'},
        {id: 'Desc_Dpto', name:'Departamento'},
        {id: 'Desc_Municipio', name:'Municipios'},
        {id: 'Desc_Estado_Rnt', name:'Estado RNT'},
        {id: 'Correo_Electronico_Reportado', name:'Correo Electronico Reportado'},
        {id: 'Usuario_Radico_Solicitud', name:'Usuario Radico Solicitud'},
        {id: 'Fecha_Ultima_Actualizacion', name:'Fecha Ultima Actualizacion'}

	];


  categoriafil: Array<CategoriaEntry> = [];
  subcategoriafil: Array<SubCategoriaEntry> = [];
  departamentofil: Array<DepartamentoEntry> = [];
  municipiofil: Array<MunicipioEntry> = [];
	estadoRnt: Array<any> = [];

	constructor(private formBuilder: FormBuilder, private reportesTramiteService: ReportesTramitesService,
		private establecimientoComercioService: EstablecimientoComercioService,	public authService: AuthService,
		private accionRntService: AccionRntService, private modalService: NgbModal,
    private basicasLoVService: BasicasLoVService, private reportesEstablecimientos: ReportesEstablecimientosService,
    private categoriaService: CampoAdicionalCategoriaService, private subcategoriaService: DocumentoSubcategoriaService
  ) {

		this.createPagingTable();
		this.createForm();

		const selectAllControl = new FormControl(false);
		const formControl = this.exportarList.map(control => new FormControl(false));
		this.exportarForm = this.formBuilder.group({
			exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
			selectAll: selectAllControl
		});

		this.paginaActual = 1;
	}

	ngOnInit() {
		this.titleTable();
		this.onCamaraSelect();
		this.onTipoSolicitudSelect();
		this.onEstadoSolicitudSelect();
		this.onChanges();


    this.onCategoriaSelectFiltro();
    this.onSubcategoriaSelectFiltro();
    this.onDepartamentosSelectFiltro();
    this.onMunicipioSelectFiltro();
    this.onEstadoRNTSelect();


	}

	createForm() {

		this.filtro = this.formBuilder.group({
			codigo_camara: [null],
			tipo_solicitud: [null],
			estado_solicitud: [null],
			fecha_inicial: [null],
			fecha_final: [null],
			numero_identificacion: [null],
			matricula: [null],
			razon_social: [null],
			codigo_rnt: [null],
			usuario: [null],
			usuario_id: [null],
			numero_radicacion: [null],
      estado_rnt_id: [null],
      categoria_id: [null],
      sub_categoria_id: [null],
      codigo_departamento: [null],
      codigo_municipio: [null]
		});

		this.formCheck = this.formBuilder.group({
			orders: new FormArray([])
		});
	}

	createPagingTable() {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
	}

	onConsultarTramite(page: number) {
		this.reportesTramiteService.getDataTable({ ...this.filtro.value, numeroPagina: page})
		.subscribe(resultado => {
			if (resultado.result) {
				this.dataTabla = resultado.data as DatoPaginadoModel;
			}
		});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarTramite(value);
	}

	filtrar() {
		this.paginaActual = 1;
		this.createPagingTable();
		this.onConsultarTramite(1);
	}

	limpiar() {
		this.filtro.reset();
		this.createPagingTable();
		this.titleTable();
		this.onCamaraSelect();
		this.onTipoSolicitudSelect();
		this.onEstadoSolicitudSelect();
	}

	titleTable() {
		this.headerTabla = ['Cámara de comercio', 'Tipo de solicitud', 'Estado de solicitud', 'Fecha de Radicación',
			'NIT', 'Matrícula', 'Nombre o Razón social', 'Identificación Usuario Trámite', 'Tipo Usuario Trámite', 'Número RNT', 'Funcionario', 'Número radicado'
    ,'Usuario radico solicitud','estado rnt','Categoria','Sub Categoria','Departamento', 'Municipio',' Correo Reportado Prestador','Fecha Ultima Actualizacion'
    ];
	}

	onCamaraSelect() {
		this.establecimientoComercioService.getCamaras().subscribe(resultado => {
			if (resultado) {
				this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
				if (this.authService.getRolUser(RolesUsuario.AdministradorCC)) {
					this.filtro
          .get('codigo_camara')
          .patchValue(this.authService.getCamaraUser());
					this.camaraComercio = (this.camarasLista.find(x => x.codigo_camara ===
						this.authService.getCamaraUser()).desc_camara);
            this.onDepartamentosSelectFiltro();
				}
			}
		});
	}

	onTipoSolicitudSelect() {
		this.reportesTramiteService.getTipoSolicitud()
		.subscribe(resultado => {
			if (resultado.result) {
				this.tipoSolicitud = resultado.data;
			}
		});
	}

	onEstadoSolicitudSelect() {
		this.reportesTramiteService.getEstadosSolicitud()
		.subscribe(resultado => {
			this.estadoSolicitud = resultado.data;
		});
	}

	onOpenModalStatus() {
		const modalRef = this.modalService.open(ModalSeleccionFuncionarioComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-xl' });
		modalRef.result.then(resultado => {
			this.filtro.get('usuario').patchValue(resultado.usuario);
			this.filtro.get('usuario_id').patchValue(resultado.usuario_id);
		}).catch(resultado => {
			this.filtro.get('usuario').patchValue(resultado.usuario);
			this.filtro.get('usuario_id').patchValue(null);
		});
	}

	onCheckDate(minDate: NgbDate) {
		this.fecha_inicio = { day: minDate.day, month: minDate.month, year: minDate.year };
	}

	onChanges() {
		this.exportarForm.get('selectAll').valueChanges.subscribe(bool => {
			this.exportarForm
				.get('exportarList')
				.patchValue(Array(this.exportarList.length).fill(bool), { emitEvent: false });
		});

		this.exportarForm.get('exportarList').valueChanges.subscribe(val => {
			const allSelected = val.every(bool => bool);
			if (this.exportarForm.get('selecAll').value !== allSelected) {
				this.exportarForm.get('selectAll').patchValue(allSelected, { emitEvent: false });
			}
		});
	}

	minSelectCheckbox(min = 1) {
		const validator: ValidatorFn = (formArray: FormArray) => {
			const totalSelected = formArray.controls.map(control => control.value)
			.reduce((prev, next) => next ? prev + next : prev, 0);

		return totalSelected >= min ? null : { required: true };
		};
		return validator;
	}

	submit() {
		const selectedPreferences = this.exportarForm.value.exportarList
		.map((checked, index) => checked ? this.exportarList[index].id : null)
		.filter(value => value !== null);

		this.columnasEnvio = selectedPreferences.join();

		this.reportesTramiteService.generarExportarTramites({ ...this.filtro.value, columnas: this.columnasEnvio })
		.subscribe(resultado => {
			if (resultado.type === HttpEventType.Response) {
				if (resultado.ok) {
				this.saveAsExcelFile(resultado.body, `reporte_tramites.xlsx`);
				}
			}
		});
	}

	private saveAsExcelFile(data: any, fileName: string): void {
		FileSaver.saveAs(data, fileName);
	}




 //#region filtros nuevo

onDepartamentosSelectFiltro() {
  if (this.filtro.value.codigo_camara == null) {
    this.filtro.value.codigo_departamento = null;
    this.basicasLoVService.getDepartamentos(null).subscribe((resultado) => {
      if (resultado.result) {
        this.departamentofil = resultado.data as Array<DepartamentoEntry>;
      }
    });
  } else {
    this.filtro.value.codigo_departamento = null;
    this.reportesEstablecimientos
      .getDepartamento({
        codigo_camara: this.filtro.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.departamentofil = resultado.data as Array<DepartamentoEntry>;
          this.onMunicipioSelectFiltro();
        }
      });
  }
}

onMunicipioSelectFiltro() {
  if (
    this.filtro.value.codigo_camara == null &&
    this.filtro.value.codigo_departamento == null
  ) {
    this.filtro.value.codigo_municipio= null;
    this.basicasLoVService.getMunicipios(null).subscribe((resultado) => {
      if (resultado.result) {
        this.municipiofil = resultado.data as Array<MunicipioEntry>;
      }
    });
  } else {
    // tslint:disable-next-line:max-line-length
    this.filtro.value.codigo_municipio= null;
    this.reportesEstablecimientos
      .getMunicipio({
        codigo_camara: this.filtro.value.codigo_camara,
        departamento_id: this.filtro.value.codigo_departamento,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.municipiofil = resultado.data as Array<MunicipioEntry>;
        }
      });
  }
}


onCategoriaSelectFiltro() {
  this.categoriaService.getCategoria().subscribe((resultado) => {
    if (resultado.result) {
      this.categoriafil = resultado.data;
    }
  });
}

onSubcategoriaSelectFiltro() {
  if (this.filtro.value.categoria_id == null) {
    this.filtro.value.sub_categoria_id= null;
    this.subcategoriaService.getSubCategoria().subscribe((resultado) => {
      if (resultado.result) {
        this.subcategoriafil = resultado.data;
      }
    });
  } else {
    this.filtro.value.sub_categoria_id= null;
    this.reportesEstablecimientos
      .getSubcategoriasXCategoria(this.filtro.value.categoria_id)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.subcategoriafil = resultado.data;
        }
      });
  }
}

	onEstadoRNTSelect() {
		this.accionRntService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estadoRnt = resultado.data;
			}
		});
	}


 //#endregion

}
